export enum SecurityFindingType {
  FirstPartyEndpoints,
  ThirdPartyEndpoints,
}
